module Meevo.Components.Controls {
    "use strict";

    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import SecurityParts = Meevo.Components.Common.SecurityParts;

    export class MeevoSublist {


        restrict = 'E';
        templateUrl = 'app/components/controls/sublistTemplate.html';

        scope = {
            baseEndpoint: "@",
            sectionEndpoint: "@",
            parentItemId: "@",
            allowCrud: "=",
            requestData: "=?",
            addTemplateUrl: "@",
            customTemplateUrl: "@",
            itemTemplateUrl: "@",
            filterTemplateUrl: "@",
            initializeAddItem: "&?",
            initializeCustomItem: "&?",
            itemSelectedAction: "&?",
            callbackTemplateAction: "&?",
            securityKey: "@?",
            sortBy: "@?",
            sortDirection: "@?",
            postSavePreMerge: "&",
            defaultCriteria: "&?",
            addBusyMessage: "@?",
            editBusyMessage: "@?",
            deleteBusyMessage: "@?",
            deleteAsUpdate: "=?",
            getFieldSecurityKeys: "&?",
            callbackOnList: "=?",
            allowPaging: "=?",          //  Whether or not to use virtual repeater in itemTemplateUrl
            asLocationId: "=?",
            context: "=?",
            applyFilterExtension: "&",
            noun: '@?',
            filterCheck: "&?",
            onOpenModal: "&?",
            dontCloseModalOnValidationException: "@",
            onCloseModal: "&?",
            noEntityId: "=?"
        };

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, formCtrl: angular.IFormController) => {
            scope.item = {};

            if (scope.filterCheck) scope.filtered = false;

            scope.allowPaging = angular.isUndefined(scope.allowPaging) ? true : scope.allowPaging;

            if (_.isFunction(scope.defaultCriteria)) {
                scope.criteria = scope.defaultCriteria();
                scope.criteria.itemsPerPage = scope.criteria.itemsPerPage || 300;
            } else {
                scope.criteria = {};
            }

            if (Meevo.Model.Guard.isNothing(scope.noEntityId)) {
                scope.noEntityId = false;
            }

            scope.$watch('parentItemId', (newValue: string, oldValue: string) => {
                if (typeof newValue === 'string' && newValue !== oldValue && newValue.length > 0) {
                    scope.parentItemId = newValue;
                    scope.items.endpoint = scope.baseEndpoint + '/' + scope.parentItemId + '/' + scope.sectionEndpoint;
                    scope.applyFilter();
                }
            });

            scope.isCentralOffice = () => {
                return this.identityService.inCentralOfficeMode();
            }

            scope.sort = { sortBy: scope.sortBy, sortDirection: scope.sortDirection === "ASC" ? Model.SortDirection.Ascending : Model.SortDirection.Descending };
            scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;

            // TODO: Review with Dave - originally thinking of leveraging the canXXXX() functions for add, edit, delete
            // for security, but there are some considerations when it comes to elevatable and the fact that the "buttons"
            // aren't actually buttons. For now using the regular directive on the add/edit/delete buttons in the template
            // and then binding to the keys built here.
            if (!_.isEmpty(scope.securityKey)) {
                scope.addSecurityKey = scope.securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE;
                scope.editSecurityKey = scope.securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
                scope.deleteSecurityKey = scope.securityKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            }
            if (_.isFunction(scope.getFieldSecurityKeys)) {
                scope.fieldSecurityKeys = scope.getFieldSecurityKeys();
            }
            /**
            * Executes the externally defined itemSelectedAction (if supplied).
            * This allows for peforming actions such as viewing details on the selected
            * item without having the sublist need to know about the implementation.
            */
            scope.selectItem = (itemId: Guid): void => {
                if (_.isFunction(scope.itemSelectedAction)) {
                    scope.itemSelectedAction(itemId);
                }
            }
            /**
            * Executes the alternative externally defined callbackTemplateAction (if supplied).
            * This allows for peforming another one item action, like itemSelectedAction,
            * without having the sublist need to know about the implementation.
            */
            scope.templateAction = (parameters: any): void => {
                if (_.isFunction(scope.callbackTemplateAction)) {
                    scope.callbackTemplateAction(parameters);
                }
            }
            /**
            * Applies any filter from the UI and initiates a request.
            */
            scope.applyFilter = (): void => {
                if (scope.filterCheck) {
                    scope.filtered = false;
                    _.each(scope.criteria, (value, key) => {
                        if (value) {
                            scope.filtered = true;
                        }
                    });
                }

                if (_.isFunction(scope.applyFilterExtension)) {
                    scope.applyFilterExtension({
                        criteria: scope.criteria,
                        subListApplyFilter: scope.applyFilter
                    });
                }
                scope.runInitSearch();
            }
            /**
            * Resets filter
            */
            scope.resetFilter = (): void => {
                // Resets to default criteria
                scope.criteria.filter = 0;
                scope.criteria.isGlobal = false;

                scope.applyFilter();
            }

            /**
             * Builds a request to retrieve the list of items in a virtualized manner.
             */
            function buildRequest<T, TSearch extends Model.SearchCriteria>(): Model.SearchPage<T, TSearch> {
                let request = <Model.SearchPage<T, TSearch>>{
                    pageNumber: 0,
                    itemsPerPage: scope.criteria.itemsPerPage || 25,
                    criteria: scope.criteria,
                    sortBy: scope.sort.sortBy,
                    sortDirection: scope.sort.sortDirection,
                    asLocationId: Model.Guard.returnSomething(scope.asLocationId)

                }

                return request;
            }
            /* START: Add New Functionality */
            /**
            * Initiates adding a new item.
            */
            scope.addNew = (): void => {
                if (_.isFunction(scope.initializeAddItem)) {
                    scope.usageTrackingLog(Meevo.Model.VerbEnum.AddNewButtonClicked, null);
                    scope.initializeAddItem()
                        .then(result => {
                            scope.viewMode = Meevo.Model.MaintenanceFormState.Adding;
                            scope.item = result;
                            if (scope.item) {
                                scope.item.asLocationId = Model.Guard.returnSomething(scope.asLocationId)
                            }
                            scope.openModal(scope.item);
                        })
                        .catch(() => {
                            scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;
                        });
                } else {
                    scope.viewMode = Meevo.Model.MaintenanceFormState.Adding;
                    scope.openModal(null);
                }
            }
            /* END: Add New Functionality */

            /* START: View Custom Functionality */
            /**
            * Initiates adding a new item.
            */
            scope.viewCustomItem = (item: any): void => {
                scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;
                if (_.isFunction(scope.initializeCustomItem)) {
                    scope.initializeCustomItem(item).then(result => {
                        scope.item = result.data;
                        scope.item.asLocationId = Model.Guard.returnSomething(scope.asLocationId)
                        scope.openModal(scope.item, scope.customTemplateUrl);
                    });
                }
            }

            /* END: View Custom Functionality */

            /* START: Edit Functionality */
            scope.editItem = (item: any): void => {
                scope.usageTrackingLog(Meevo.Model.VerbEnum.EditButtonClicked, null);
                scope.viewMode = Meevo.Model.MaintenanceFormState.Editing;
                scope.openModal(item);
            }

            /* END: Edit Functionality */

            /*  START: Delete Functionality
            *   Handles confirmation and deletion of an item.
            */
            scope.deleteItem = (item: any, confirmationMessage: string = null): void => {
                confirmationMessage = confirmationMessage || "MESSAGE_DELETE_CONFIRMATION";
                this.modalService.warning(confirmationMessage, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' }).then((confirmResult: boolean) => {
                    if (confirmResult) {
                        angular.extend(scope.item, scope.requestData || {});

                        if (!_.isEmpty(scope.deleteBusyMessage)) {
                            this.busyService.start(scope.deleteBusyMessage);
                        }
                        this.loggingService.trace(`Deleting item ${item.id}`);
                        if (scope.deleteAsUpdate && scope.deleteAsUpdate === true) {
                            if (item.hasOwnProperty("isDeleting")) {
                                item.isDeleting = true;
                            }
                            scope.usageTrackingLog(Meevo.Model.VerbEnum.DeleteButtonClicked, null);
                            this.dataService.update(scope.baseEndpoint, item, scope.parentItemId, scope.sectionEndpoint, scope.asLocationId)
                                .then((data: any) => {
                                    scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;
                                    if (!_.isEmpty(scope.deleteBusyMessage)) {
                                        this.busyService.stop();
                                    }
                                    this.loggingService.trace(`${scope.item.id} Successfully Updated`);
                                    scope.runInitSearch();
                                    /* for Events Validation Exception  */
                                    if (data.isValidationException !== true || data.isValidationException == undefined || data.isValidationException == null) {
                                        scope.cancel(false);
                                    }
                                });
                        } else {
                            scope.usageTrackingLog(Meevo.Model.VerbEnum.DeleteButtonClicked, null);
                            this.dataService.delete(scope.baseEndpoint, scope.parentItemId, item.entityVersion, scope.asLocationId, scope.sectionEndpoint, item.id, scope.requestData)
                                .then((data: any) => {
                                    if (!_.isEmpty(scope.deleteBusyMessage)) {
                                        this.busyService.stop();
                                    }

                                    scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;
                                    item.isEditing = false;
                                    this.loggingService.trace(`${item.id} Successfully Deleted`);
                                    scope.runInitSearch();
                                });
                        }
                    }
                });
            }

            /* END: Delete Functionality */

            /** START: Common Functionality
            *   Handles Persisting an item during an Add/Edit session.
            */
            scope.save = (): void => {
                angular.extend(scope.item, scope.requestData || {});
                if (scope.viewMode === Meevo.Model.MaintenanceFormState.Adding) {
                    if (!_.isEmpty(scope.addBusyMessage)) {
                        this.busyService.start(scope.addBusyMessage);
                    }
                    this.loggingService.trace(`Adding item`);
                    scope.usageTrackingLog(Meevo.Model.VerbEnum.SaveButtonClicked, null);
                    this.dataService.add(scope.baseEndpoint, scope.item, scope.parentItemId, scope.sectionEndpoint, scope.asLocationId).
                        then((data: any): any => {

                            if (!_.isEmpty(scope.addBusyMessage)) {
                                this.busyService.stop();
                            }
                            scope.item = {};
                            scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;
                            scope.runInitSearch();
                            scope.cancel(false);
                        })
                        .catch(() => {
                            if (!scope.dontCloseModalOnValidationException) {
                                scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;
                            }
                        });
                } else if (scope.viewMode === Meevo.Model.MaintenanceFormState.Editing) {
                    if (!_.isEmpty(scope.editBusyMessage)) {
                        this.busyService.start(scope.editBusyMessage);
                    }
                    this.loggingService.trace(`Updating item ${scope.item.id}`);
                    scope.usageTrackingLog(Meevo.Model.VerbEnum.SaveButtonClicked, null);
                    this.dataService.update(scope.baseEndpoint, scope.item, scope.parentItemId, scope.sectionEndpoint, scope.asLocationId)
                        .then((data: any) => {
                            // Hook to provide notification before merging item into list
                            if (scope.postSavePreMerge) {
                                scope.postSavePreMerge({ data: data });
                            }

                            angular.merge(scope.item, data);
                            scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;

                            if (!_.isEmpty(scope.editBusyMessage)) {
                                this.busyService.stop();
                            }

                            this.loggingService.trace(`${scope.item.id} Successfully Updated`);
                            scope.runInitSearch();

                            /* for Events Validation Exception  */
                            if (data.isValidationException !== true || data.isValidationException == undefined || data.isValidationException == null) {
                                scope.cancel(false);
                            }
                        }).catch(() => {
                            if (!scope.dontCloseModalOnValidationException) {
                                scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;
                                scope.runInitSearch();
                            }
                        });
                }
            }

            scope.$on(Meevo.Components.Common.Messages.SERVER_VALIDATION_COMPLETE, (event: angular.IAngularEvent) => {
                if (!_.isEmpty(scope.editBusyMessage)) {
                    this.busyService.stop();
                }
                if (!scope.dontCloseModalOnValidationException) {
                    scope.cancel();
                }
            });

            scope.cancel = (isActualCancel: boolean = true): void => {
                scope.item = {};
                scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;
                this.$mdDialog.cancel();
                if (_.isFunction(scope.onCloseModal)) {
                    scope.onCloseModal({ item: scope.item, isSave: !isActualCancel });
                }
            }

            /**
            * Opens modal for adding or editing an item.
            */
            scope.openModal = (item: any, templateUrl: any = scope.addTemplateUrl) => {
                (_.isFunction(scope.onOpenModal) ? scope.onOpenModal({ item: item }) : this.$q.resolve())
                    .then(() => {
                        let dialog = this.$mdDialog;

                        scope.item = angular.copy(item || {});

                        let options = {
                            templateUrl: templateUrl,
                            controller: 'meevo.components.controls.SublistModalController',
                            controllerAs: 'vm',
                            locals: {
                                item: scope.item,
                                parentScope: scope,
                                context: scope.context,
                                viewMode: scope.viewMode
                            }
                        };

                        dialog.show(options);
                    })
                    .catch(() => {
                        scope.viewMode = Meevo.Model.MaintenanceFormState.Readonly;
                    });
            }

            /* END: Common Functionality */

            /* START image Carousel */

            scope.showCarouselView = (index: any, itemList: any, imageParent: any, searchCriteria: any) => {
                let dialog = this.$mdDialog;
                itemList.children = (searchCriteria == 0)
                    ? itemList.children
                    : _.where(itemList.children, { objectState: searchCriteria });
                scope.imageList = itemList;
                scope.carouselIndex = index;
                scope.imageParent = imageParent;

                let options = {
                    controller: 'meevo.components.controls.SublistModalController',
                    templateUrl: "app/components/imageGallery/templates/imageGallery.carouselview.template.html",
                    controllerAs: 'vm',
                    locals: {
                        item: scope.item,
                        parentScope: scope,
                        context: scope.context,
                        viewMode: scope.viewMode,
                        preserveScope: true,
                    }
                };
                dialog.show(options);
            }

            /* End image Carousel */

            /* START CRUD State Management */

            scope.canAdd = (): boolean => {
                return scope.viewMode === Meevo.Model.MaintenanceFormState.Readonly;
            }

            scope.canEdit = (): boolean => {
                return scope.viewMode === Meevo.Model.MaintenanceFormState.Readonly;
            }

            scope.canDelete = (): boolean => {
                return scope.viewMode === Meevo.Model.MaintenanceFormState.Readonly;
            }

            scope.isAdding = (): boolean => {
                return scope.viewMode === Meevo.Model.MaintenanceFormState.Adding;
            }

            scope.isEditing = (): boolean => {
                return scope.viewMode === Meevo.Model.MaintenanceFormState.Editing;
            }

            /* END: CRUD State Management */

            scope.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, scope.baseEndpoint + "/" + scope.parentItemId + "/" + scope.sectionEndpoint, null, null, null, scope.callbackOnList);

            if (scope.allowPaging) {
                scope.runInitSearch = () => {
                    if (Meevo.Model.Guard.isSomething(scope.parentItemId) || scope.noEntityId) {
                        scope.items.initSearch(buildRequest())
                    }
                    else {
                        scope.items.clearSearch();
                    }
                };
            } else {
                scope.runInitSearch = () => {
                    if (Meevo.Model.Guard.isSomething(scope.parentItemId) || scope.end || scope.noEntityId) {
                        scope.items.initSearch(buildRequest()).then((result: any) => {
                            scope.items.getItemAtIndex(buildRequest().pageNumber);
                        });
                    }
                    else {
                        scope.items.clearSearch();
                    }
                };
            }

            scope.applyFilter();

            scope.usageTrackingLog = (verbEnum, payload): void => {
                if (scope.noun && scope.noun !== null) {
                    var trackingItem = new Meevo.Model.TrackingItem(scope.noun, verbEnum, payload, scope.parentItemId);
                    this.trackingService.saveTrackingInfo(trackingItem);
                }
            }

        }

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private loggingService: Meevo.Components.Logging.ILoggingService,
            private $mdDialog: ng.material.IDialogService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $q: angular.IQService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = (dataService: Meevo.Components.BaseClasses.IDataService,
                modalService: Meevo.Components.Modal.IModalService,
                loggingService: Meevo.Components.Logging.ILoggingService,
                $mdDialog: ng.material.IDialogService,
                securityService: Meevo.Components.Common.ISecurityService,
                busyService: Meevo.Components.Busy.IBusyService,
                identityService: Meevo.Components.Common.IIdentityService,
                trackingService: Meevo.Components.Tracking.ITrackingService,
                $q: angular.IQService) => {
                return new MeevoSublist(dataService, modalService, loggingService, $mdDialog, securityService, busyService, identityService, trackingService, $q);
            }

            directive.$inject = [
                "meevo.components.common.DataService",
                "meevo.components.modal.ModalService",
                "meevo.components.logging.LoggingService",
                "$mdDialog",
                "meevo.components.common.SecurityService",
                "meevo.components.busy.BusyService",
                "meevo.components.common.IdentityService",
                "meevo.components.tracking.TrackingService",
                "$q"
            ];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoSublist", MeevoSublist.factory());

}